/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaskTypeDescription = {
    ManualTask: 'ManualTask',
    BeamConstancyCheck: 'BeamConstancyCheck',
    TrackItImport: 'TrackItImport'
} as const;
export type TaskTypeDescription = typeof TaskTypeDescription[keyof typeof TaskTypeDescription];


export function TaskTypeDescriptionFromJSON(json: any): TaskTypeDescription {
    return TaskTypeDescriptionFromJSONTyped(json, false);
}

export function TaskTypeDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskTypeDescription {
    return json as TaskTypeDescription;
}

export function TaskTypeDescriptionToJSON(value?: TaskTypeDescription | null): any {
    return value as any;
}

/**
 * Check if a given object implements the TaskTypeDescription interface.
 */
 export function instanceOfTaskTypeDescription(value: any): value is TaskTypeDescription {
    return Object.values(TaskTypeDescription).includes(value)
}

